// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addresses-list[data-v-927d86aa] {\n  background-color: white;\n  color: black;\n}\n.addresses-list-element[data-v-927d86aa] {\n  padding: 10px;\n}\n.addresses-list-element[data-v-927d86aa]:hover {\n    background-color: #e2e2e2;\n}\ninput[data-v-927d86aa]:disabled {\n  background-color: #dadada;\n}\nselect[data-v-927d86aa]:disabled {\n  background-color: #dadada;\n}\n", ""]);
// Exports
module.exports = exports;
